import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-100px)] bg-gray-800 text-text-white p-6">
      <div className="text-center p-8 bg-gray-700 rounded-lg shadow-md border border-border-subtle">
        <h1 className="text-6xl font-bold text-accent-red mb-4">404</h1>
        <p className="text-xl text-text-white mb-8">Page Not Found</p>
        <p className="text-text-gray mb-8">The page you're looking for doesn't exist or an other error occurred.</p>
        <Link to="/dashboard" className="mt-6 inline-block bg-accent-red hover:bg-red-700 text-white font-bold py-2 px-4 rounded-md transition duration-300">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;